import { useEffect, useState } from 'react';
import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { storageService } from 'infrastructure/services/StorageService';
import { TUpdate } from 'domain/types';
import {
  CreateJobPostConfigContext,
  TCreateJobPostContextState,
} from 'domain/createJobPostConfig/CreateJobPostContext';
import { useContextSelector as useCS } from 'use-context-selector';
import { createJobPostConfigSelectors } from 'domain/createJobPostConfig/selectors';

export const useGetJobPostById = (): any => {
  const update: TUpdate<TCreateJobPostContextState> | undefined = useCS(
    CreateJobPostConfigContext,
    createJobPostConfigSelectors.update
  );
  const [jobPostId, setJobPostId] = useState<number | null>(null);
  const [shouldFetch, setShouldFetch] = useState(false);

  useEffect(() => {
    storageService.getItem('createJobPostId').then((jobPost) => {
      if (!jobPost) return;
      const id = Number(jobPost);
      setJobPostId(id);
      setShouldFetch(true);
    });
  }, []);

  const { data, isLoading, status, error } = useRequest({
    url: shouldFetch ? `/api/v1/jobPosts/${jobPostId}` : '',
    method: ApiMethodsEnum.Get,
    sendOnStart: shouldFetch,
  });

  useEffect(() => {
    if (isLoading) return;

    if (error || status === 404) {
      storageService.removeItem('createJobPostId');
      setJobPostId(null);
      setShouldFetch(false);
      return;
    }

    if (!data || status !== 200) return;

    if (update) update({ createJobPostData: data, screeningQuestions: data?.faq || [] });
    setJobPostId(null);
    setShouldFetch(false);
  }, [data, isLoading, error, status]);

  return {
    isLoading,
  };
};
